import ResponsiveStyleSheet from "react-native-media-query";
import { createResponsiveStyles, theme } from "@clearabee/ui-library-native";

export const { styles, ids } = ResponsiveStyleSheet.create({
  panel: createResponsiveStyles({
    base: {
      marginBottom: theme.spacing.small,
      padding: 0,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      position: "relative",
      overflow: "visible",
    },
    medium: {
      marginBottom: theme.spacing.medium,
    },
  }),
  BookServicePillContainer: createResponsiveStyles({
    base: {
      marginBottom: theme.spacing.small,
    },
  }),
  orderTrackingButtonContainer: createResponsiveStyles({
    base: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      marginTop: 0,
    },
    medium: {
      marginTop: theme.spacing.small,
    },
  }),
});
